import { frontendURL } from '../../../helper/URLHelper';
import DataRegistryIndex from './pages/DataRegistryIndex.vue';
import { DATA_REGISTRY_VIEW_PERMISSIONS } from './utils/dataRegistryConsole';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/data-registry'),
    alias: [
      frontendURL('accounts/:accountId/lais-data-registry'),
      frontendURL('accounts/:accountId/dados-publicos'),
    ],
    name: 'lais_data_registry_index',
    component: DataRegistryIndex,
    meta: { permissions: DATA_REGISTRY_VIEW_PERMISSIONS },
  },
];
